/**
 * 点数分析資格（単一選択）が未選択のときに QuickSight へ送る値。
 *
 * 5.2.8 のデータセット（specific-certification-holder）のカスタムSQLは、この値を「点数分析資格の指定なし」として扱う。 空配列で送るとパラメータが未設定（NULL）になり、SQL
 * を組み立てられずダッシュボードが表示されないため、未選択時はこの値に置き換える。
 */
export const NO_SCORE_ANALYSIS_CERT = 'default_kuWdpGRu'

/**
 * フィルターの状態を QuickSight の setParameters 用の配列に変換する
 *
 * @param {Record<string, string[]>} state - コントロールIDごとの選択値（generateOutput の結果）
 * @param {string[]} patterns - QuickSight に渡すパラメータ名の正規表現（FilterConfig の filterParameter）
 * @returns {{ Name: string; Values: string[] }[]} QuickSight のパラメータ
 */
export function toQuicksightParameters(state, patterns = []) {
  const parameters = Object.keys(state).filter((item) => patterns.some((e) => item.match(new RegExp(e))))

  return parameters.map((id) => {
    let filterValues = state[id]

    if (id.includes('department')) {
      filterValues = filterValues.concat('-')
    }

    if (id === 'score' && filterValues.includes('')) {
      filterValues = ['-1']
    }

    if (id === 'scoreAnalysisCert' && filterValues.length === 0) {
      filterValues = [NO_SCORE_ANALYSIS_CERT]
    }

    return {
      Name: id,
      Values: filterValues
    }
  })
}
